export default function isUrlFullyMatched(url, path) {
  var lastMatch = path[path.length - 1];
  return lastMatch && (lastMatch.remaining === '' || lastMatch.remaining === '/');
}